module.exports = __webpack_public_path__ + "static/cinsa_dimensiones_lineas_oscuras-4c40ca8bfaceb9eeb4f82c45e18361a6.png";